import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/mobile/8_section_icons.png'


const _hoisted_1 = { class: "flex flex-col px-10" }
const _hoisted_2 = { class: "flex items-center justify-center relative mb-12" }
const _hoisted_3 = { class: "flex gap-x-6 w-full" }
const _hoisted_4 = { class: "flex flex-col px-1 py-3 my-auto" }
const _hoisted_5 = { class: "grid grid-cols-[12px_auto] gap-x-2 items-center mb-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 bg-[var(--secondary-color)] rounded-full" }, null, -1)
const _hoisted_7 = { class: "grid grid-cols-[12px_auto] gap-x-2 items-center pl-5 mb-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 bg-[var(--secondary-color)] rounded-full" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

import BaseButton from '@/components/common/BaseButton.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'EighthSection',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseButton, {
        text: _unref(t)('main-page.additional.title'),
        type: "subtitle-m",
        "padding-x": "54",
        "padding-y": "12",
        color: "var(--black-color)",
        ui: "primary"
      }, null, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.additional.organization'),
            type: "subtitle2-m"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.additional.reserv'),
            type: "subtitle2-m"
          }, null, 8, ["text"])
        ])
      ]),
      _hoisted_9
    ])
  ]))
}
}

})